import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { clearAuthAndRedirect } from '../../lib/utils/authUtils';
import { getAdminSession, getMyProfile } from '../../api/adminApi';
import { AdminSchema } from '../types/AdminSchema';
import { User } from '../../api/types';

const isBrowser = typeof window !== 'undefined';

const initialState: AdminSchema = {
  isLoaded: false,
  isFetching: false,
  isAuth: isBrowser ? localStorage.getItem('isAuth') === 'true' : false,
  profile: null,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setIsAuth: (state: Draft<AdminSchema>, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload;
      if (isBrowser) {
        localStorage.setItem('isAuth', action.payload.toString());
      }
    },
    setProfile: (state: Draft<AdminSchema>, action: PayloadAction<User | null>) => {
      state.profile = action.payload;
      if (isBrowser && action.payload) {
        localStorage.setItem('user', JSON.stringify(action.payload));
      }
    },
    logout: (state: Draft<AdminSchema>) => {
      state.isAuth = false;
      state.profile = null;
      if (isBrowser) {
        localStorage.removeItem('isAuth');
        localStorage.removeItem('user');
        LocalStorageService.clearAllTokens();
      }
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(getAdminSession.matchFulfilled, (state: Draft<AdminSchema>, action) => {
      state.isLoaded = true;
      state.isFetching = false;
      state.isAuth = action.payload.isAuth;
      localStorage.setItem('isAuth', action.payload.isAuth.toString());
    });
    builder.addMatcher(getAdminSession.matchPending, (state: Draft<AdminSchema>) => {
      state.isFetching = true;
    });
    builder.addMatcher(getAdminSession.matchRejected, (state: Draft<AdminSchema>) => {
      state.isLoaded = true;
      state.isFetching = false;
      state.isAuth = false;
      if (isBrowser) {
        clearAuthAndRedirect('/login');
      }
    });
    builder.addMatcher(getMyProfile.matchFulfilled, (state: Draft<AdminSchema>, action) => {
      state.profile = action.payload.data.user;
      if (isBrowser) {
        localStorage.setItem('user', JSON.stringify(action.payload.data.user));
      }
    });
  },
});

export const { actions: adminActions } = adminSlice;
export const { reducer: adminReducer } = adminSlice;
